// extracted by mini-css-extract-plugin
export default {"localeSelector":"DestinationEditorPage_localeSelector__LVjEA","title":"DestinationEditorPage_title__j03rA"};